var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fun-footer"},_vm._l((_vm.datas),function(data,index){return _c('span',{key:index,class:_vm.judgeColor(data),on:{"click":function($event){return _vm.clickthing(data.name)}}},[_c('img',{attrs:{"src":_vm.judge(data),"alt":""}}),_vm._v(" "+_vm._s(data.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }